import Tabs from '../components/Tabs';
import {
  excludedProductListForPermissableProducts,
  productNameToExclude,
} from '../constant/constant';
import {
  ListMedicationsProps,
  ProductFormulation,
  ProductTypes,
  TabItem,
} from '../interface/interface';
import { ListMedications } from './ListMedications';

export const PatientOrderTab = ({
  products,
  addProductToCart,
  removeProductFromCart,
  nonOrderable,
  isHome,
}: ListMedicationsProps) => {
  const tabs: Array<TabItem> = [
    {
      id: '1',
      label: 'Treatment Plan',
      component: (
        <ListMedications
          products={products?.filter(
            (product) =>
              (![ProductFormulation.TEST_KIT].includes(
                product?.productFormulation?.name,
              ) &&
                !product?.isAllowed &&
                product.is_shop_product) ||
              excludedProductListForPermissableProducts.includes(product.name),
          )}
          addProductToCart={addProductToCart}
          removeProductFromCart={removeProductFromCart}
          nonOrderable={nonOrderable?.filter(
            (product) =>
              !(
                [ProductTypes.ACCESSORIES, ProductTypes.DEVICE] as string[]
              ).includes(product?.product_type) &&
              !productNameToExclude.includes(product.name),
          )}
          isHome={isHome}
        />
      ),
    },
    {
      id: '2',
      label: 'Accessories',
      component: (
        <ListMedications
          products={products?.filter((product) => {
            const hasDrugKits =
              product?.productFormulation?.name?.trim() ===
              ProductFormulation.TEST_KIT;

            const isAllowed = product?.isAllowed === true;

            const nonShopProduct = product.is_shop_product === false;

            const hasPrimaryAccessory =
              excludedProductListForPermissableProducts.includes(product.name);

            return (
              (hasDrugKits || isAllowed || nonShopProduct) &&
              !hasPrimaryAccessory
            );
          })}
          isHome={isHome}
          addProductToCart={addProductToCart}
          removeProductFromCart={removeProductFromCart}
          nonOrderable={nonOrderable?.filter((product) => {
            const isMatchingType = [
              ProductTypes.ACCESSORIES,
              ProductTypes.DEVICE,
            ].includes(product?.product_type as ProductTypes);
            const isNotInProductArray = !products?.some(
              (p) => p.id === product.id,
            );
            const isAllowed = !products?.some((p) => p.id === p?.isAllowed);
            return isMatchingType && isNotInProductArray && isAllowed;
          })}
        />
      ),
    },
  ];

  const tabData = localStorage.getItem('homeTab');
  const activeTab = tabs[tabData === '1' ? 0 : 1].label;

  return <Tabs tabs={tabs} activeTabLabel={activeTab} isHome={isHome} />;
};
